<template>
  <div class="debugInfo">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header :title="title"/>

    <!-- 链接 -->
    <mt-cell title="LOG按钮">
      <mt-switch v-model="showConsole" @change="changeShowConsole" >{{showConsole?'显示':'隐藏'}}</mt-switch>
    </mt-cell>

  </div>                                                                                                        
</template>

<script>
import Body from '@/mixins/body'
import { storage } from '@/utils'
let isShowConsole = false
isShowConsole = storage.debugInfoShowConsole().getItem()['showConsole'] === 1
export default {
  name: 'debugInfo',
  mixins: [Body],
  data() {
    return {
      title: '调试中心',
      showConsole: isShowConsole
    }
  },
  activated() {
  },
  methods: {
    changeShowConsole() {
      storage.debugInfoShowConsole().setItem(this.showConsole ? { 'showConsole': 1 } : {})
    }
  }
}
</script>

<style lang="scss" scoped>
.debugInfo {
 
}
</style>
